import { createAction } from 'redux-actions';
export const siteInfoLoad = createAction('SITE_INFO_LOAD');
export const siteInfoLoaded = createAction('SITE_INFO_LOADED');
export const loadSpinner = createAction('LOAD_SPINNER');
